export const updateUser = ({commit}, user) => {
    commit('userState', user)
}
export const updateToken = ({commit}, token) => {
    commit('setToken', token)
}


// WEBPACK FOOTER //
// ./src/store/actions.js